import { render, staticRenderFns } from "./CatalogWorkflow.vue?vue&type=template&id=9b2d4e5a&scoped=true"
import script from "./CatalogWorkflow.vue?vue&type=script&lang=js"
export * from "./CatalogWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2d4e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b2d4e5a')) {
      api.createRecord('9b2d4e5a', component.options)
    } else {
      api.reload('9b2d4e5a', component.options)
    }
    module.hot.accept("./CatalogWorkflow.vue?vue&type=template&id=9b2d4e5a&scoped=true", function () {
      api.rerender('9b2d4e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/CatalogWorkflow.vue"
export default component.exports